import { paths } from "@rms-types/constants/paths";
import { lazy } from "react";

import { AppRoute } from "@/routes/types";

export const complianceRoutes: AppRoute[] = [
  {
    index: true,
    permissions: paths.app.compliance.permissions,
    page: lazy(() => import("@/pages/compliance").then((module) => ({ default: module.Compliance }))),
  },
  {
    path: paths.app.compliance.attachmentGroup.path,
    permissions: paths.app.compliance.attachmentGroup.permissions,
    page: lazy(() =>
      import("@/pages/compliance/attachmentGroupId").then((module) => ({
        default: module.ComplianceAttachmentsPage,
      }))
    ),
  },
];
